import React from 'react';
import { IOldIconProps } from './type';

const AddCart: React.FC<IOldIconProps> = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.287 5.767a.75.75 0 00.48.946l1.954.64a2.25 2.25 0 011.48 1.584l2.54 9.988c.198.776.63 1.444 1.209 1.935a3.75 3.75 0 105.05.89h7a3.75 3.75 0 104.876-.998 3.743 3.743 0 001.003-1.547l2.831-8.348a.75.75 0 00-1.42-.482l-2.831 8.348a2.25 2.25 0 01-2.131 1.527H11.376a2.25 2.25 0 01-2.18-1.695l-2.54-9.988a3.75 3.75 0 00-2.468-2.639l-1.954-.64a.75.75 0 00-.947.479zm15.974-.517a.75.75 0 00-.75.75V9.866H12.565a.75.75 0 100 1.5H16.511V15.23h.75-.75a.75.75 0 101.5 0h-.75.75V11.366H21.956a.75.75 0 100-1.5H18.011V6a.75.75 0 00-.75-.75zM11 21.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM21.75 24a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z"
      />
    </svg>
  );
};

export default AddCart;
